'use client';

import { FormProvider } from '../../Form/FormContext';
import { BountyFormProps } from './BountyForm.types';
import { bountyFormSchema, bountyFormSteps } from './BountyForm.utils';
import { BountyFormContent } from './BountyFormContent';

export const BountyForm = ({ bounty }: BountyFormProps) => {
  const formSteps = bountyFormSteps(bounty);

  return (
    <FormProvider schema={bountyFormSchema} steps={formSteps}>
      <BountyFormContent bounty={bounty} />
    </FormProvider>
  );
};
